module.exports = __webpack_public_path__ + "static/media/hf.6a0fdc77.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/hf.png
// module id = 655
// module chunks = 0 1